import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
import { I18nBlockContentSchema } from '../ui/blockContent';
import { ImageAssetSchema } from '../ui/imageAsset';
export const TipSchema = z.object({
    _id: z.string(),
    name: I18nStringSchema,
    description: I18nBlockContentSchema,
    icon: ImageAssetSchema.optional()
});
//# sourceMappingURL=tip.js.map